import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { OtpComponent } from './components/login/otp/otp.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { MenuComponent } from './components/menu/menu.component';
import { FormatAddressPipe } from './pipes/format-address.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencyPipe } from './pipes/currency.pipe';
import { NotifyRiderComponent } from './components/notify-rider/notify-rider.component';

const componentArray = [LoginComponent,OtpComponent, MenuComponent, NotifyRiderComponent];

@NgModule({
  declarations: [...componentArray, FormatAddressPipe, CurrencyPipe],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    TranslateModule
  ],
  exports: [...componentArray, FormatAddressPipe, CurrencyPipe],
})
export class SharedModule { }
